import { rem } from "polished";
import React from "react";
import styled, { css } from "styled-components";
import {
  changeBottom,
  changeCurrentEvent,
  changeLeft,
  changeLineAlignment,
  changeRight,
  changeTileShape,
  changeTop,
  changeVariation,
  getSelectedTile,
} from "../../../../../../lib/redux/slices/dimensions-slice";
import { useDispatch, useSelector } from "react-redux";
import { unslugify } from "../../../../../../utils/canvas/utils";
import { useUpdateCart } from "../../../../../../hooks/use-update-cart";

const TileTypeSelect = ({ data, stage, canvasOffsetX, calculatePrice }) => {
  const selectedTile = useSelector(getSelectedTile);
  const dispatch = useDispatch();
  const { updateCart } = useUpdateCart();

 
  const { default_bottom_width,
    default_left_height,
    default_right_height,
    default_top_width} = selectedTile?.settings?.configuration?.horizontal

  const changeCurrentTile = (tileType, selectedTile) => {
    if(default_top_width) {
      dispatch(changeTop(parseInt(default_top_width)));
    }
    if(default_left_height) {
      dispatch(changeLeft(parseInt(default_left_height)));
    }
    if(default_bottom_width) {
      dispatch(changeBottom(parseInt(default_bottom_width)));
    }
    if(default_right_height) {
    dispatch(changeRight(parseInt(default_right_height)));
    }

    dispatch(
      changeTileShape({
        tileShape: tileType,
        selectedTile,
      })
    );
    if (tileType === "rak") {
      dispatch(changeLineAlignment(selectedTile.variations[1].type));
      dispatch(changeVariation(selectedTile.variations[1]));
    } else {
      dispatch(changeLineAlignment(selectedTile.variations[0].type));
      dispatch(changeVariation(selectedTile.variations[0]));
    }

    updateCart((storeData) => {
      const choosedTile =
        tileType === "rak"
          ? selectedTile.variations[1]
          : selectedTile.variations[0];

      return {
        ...storeData,
        dimensions: {
          ...storeData.dimensions,
          tileShape: tileType,
          selectedTile,
          lineAlignment: choosedTile.type,
          selectedVariation: choosedTile,
        },
      };
    });
  };

  if (!data) return void 0;

  const onShapeVariationChange = (currentValue, dataValue) => {
    dispatch(changeCurrentEvent("shape"));
    changeCurrentTile(currentValue, dataValue);
  };

  return (
    <Layout className="builder-element-select">
      <div className="element">
        {/* <h5>Variations</h5> */}
        <h5>Bänkskiva</h5>

        {/* <select
          onChange={(e) => {
            onShapeVariationChange(e.target.value, data[e.target.value]);
          }}
        >
          {Object.entries(data).map((option, i) => {
            return (
              <option
                value={option[0]}
                key={option[0]}
                selected={option[0] === selectedTile.name}
              >
                {option[1].label || unslugify(option[0])}
              </option>
            );
          })}
        </select> */}
        <div className="options-list">
          {Object.entries(data).map(([key, value]) => {
            return (
              <label
              className="options"
                // value={option[0]}
                key={key}
                data-selected={key === selectedTile.name}
              >
                <div class="image">
                  <img src={value?.image || value.variations[0].center_image} alt={value.label || key} />
                </div>
                {value.label || unslugify(key)}

                <input type="radio" id="html" name={key} value={key} checked={key === selectedTile.name}  onChange={(e) => {onShapeVariationChange(e.target.value, data[e.target.value])}} hidden/>
              </label>
            );
          })}
        </div> 
         
      </div>
    </Layout>
  );
};
export default TileTypeSelect;

const Layout = styled.div`
  ${({ theme }) => css`
    margin-bottom: ${rem(15)};

    .element {
      h5 {
        margin-bottom: ${rem(15)};
        font-size: 14px;
        font-weight: bold;
      }

      .options-list{
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 15px;

        .options{
          padding: 20px 10px;
          border-radius: 30px;
          background-color:  ${theme.colors.white};
          text-align: center;
          color: ${theme.colors.black};
          transition: 0.3s ease all;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          cursor: pointer;

          .image {
            margin-bottom: 5px;
            img {
              max-width: 60%;
              vertical-align: middle;
              max-height: 65px;
            }
          }

          &[data-selected="true"] {
            background-color:${theme.colors.primary};
            color: ${theme.colors.white}
          }

        }
      }

      

      select {
        width: 100%;
        min-height: 30px;
        border-bottom: 1px solid ${theme.colors.gray["600"]};
        border-radius: 0;
        outline: none;
        box-shadow: none;
      }
    }
  `}
`;
